import { Component, Input, OnInit } from '@angular/core';
import { AppSettings } from 'src/app/configs/app.settings';
import { BrowserHelper } from 'src/app/core/helper/browser.helper';

@Component({
  selector: 'app-raffle-footer',
  templateUrl: './raffle-footer.component.html',
  styleUrls: ['./raffle-footer.component.scss'],
})
export class RaffleFooterComponent implements OnInit {

  @Input() compact: boolean = false;

  constructor(private browserHelper: BrowserHelper) { }

  get v() { return AppSettings.version; }
  get year() { return new Date().getFullYear(); }

  ngOnInit() {
  }

  async runRaffle() {
    this.browserHelper.openUrl('http://admin.raffle-rocket.com/');
  }
}
